import { useMediaQuery } from "@chakra-ui/react";
import { useCallback, useRef } from "react";

export function useParamQuery() {
  return new URLSearchParams(window.location.search);
}

export function useCheckMobile() {
  return useMediaQuery("(max-width: 760px)")[0];
}

export function useDebounce<T extends unknown[]>(
  fn: (...args: T) => void,
  delay: number,
) {
  const timeout = useRef<ReturnType<typeof setTimeout> | null>(null);

  const debounced = useCallback(
    (...args: T) => {
      if (timeout.current) clearTimeout(timeout.current);

      timeout.current = setTimeout(() => {
        fn(...args);
        timeout.current = null;
      }, delay);
    },
    [fn, delay],
  );

  return debounced;
}
